import { isMobile } from './isMobile';
import { userSettingsStore } from '../../store/userSettingsStore';
import { detectSocketPath } from '../constants/socketPathName';
import { parseQuery } from './parseQuery';
import { userInfoStore } from '../../store/userInfoStore';
import { resizeGame } from '../constants/resizeGame';
import { applicationStore } from '../../store/applicationStore';
import { partnerSkinConfigs, partnerSkinEnums } from '../constants/partnerSkinEnums';
import { FAST_TRADE_GAME_ID } from '../../games/fastTrade/fastTradeCore/constants';

export const init = () => {
  const query = parseQuery(window.location.search);
  const { playerexternalid, currencysymbol, currency, skin, showloader, gameid } = query;

  if (skin && Object.keys(partnerSkinEnums).includes(skin)) {
    applicationStore.setPartnerSkin(partnerSkinEnums[skin]);
  } else {
    applicationStore.setPartnerSkin(partnerSkinEnums.pg);
  }

  applicationStore.setShowSkinLoader(!!+showloader && skin && partnerSkinConfigs[skin].hasLoader);

  if (partnerSkinEnums[skin] !== partnerSkinEnums.topc) {
    userInfoStore.setCurrencyCodeAbbr(currency);
  } else {
    applicationStore.setHasDepositPopup(true);
  }
  userInfoStore.setCurrencyCode(currencysymbol);
  userInfoStore.setCurrencyFromToken(currency);
  userInfoStore.setUserId(playerexternalid);

  if (isMobile()) {
    document.documentElement.classList.add('is-mobile');
    document.documentElement.classList.remove('is-web');
  } else {
    resizeGame(false, FAST_TRADE_GAME_ID === +gameid);
    window.addEventListener('resize', () => {
      resizeGame(false, FAST_TRADE_GAME_ID === +gameid);
    });
    document.documentElement.classList.add('is-web');
    document.documentElement.classList.remove('is-mobile');
  }
  const gameName = detectSocketPath(
    window.location.pathname === '/' ? 'dice' : window.location.pathname
  );

  userSettingsStore.localStorageAndUserSettingsInit({ gameName });
};
